// Every public route, in one list. App.js renders them, scripts/prerender.js
// writes each one to static HTML after the build, and scripts/sitemap.js
// lists the indexable ones. Plain data with no imports, so those Node
// scripts can import it too.
//   path       the URL
//   page       the page component, named in App.js's PAGES
//   content    its copy in src/content; the sitemap dates the page from this
//              file's last commit
//   indexable  false for a noindex page, which stays out of the sitemap
//   file       where the prerender saves it, when not <path>.html
export const ROUTES = [
  { path: '/', page: 'HomePage', content: 'home.js', indexable: true },
  { path: '/product', page: 'ProductPage', content: 'product.js', indexable: true },
  { path: '/security', page: 'SecurityPage', content: 'security.js', indexable: true },
  { path: '/ai-features', page: 'AIFeaturesPage', content: 'aiFeatures.js', indexable: true },
  { path: '/use-cases', page: 'UseCasesPage', content: 'useCases.js', indexable: true },
  { path: '/how-it-works', page: 'HowItWorksPage', content: 'howItWorks.js', indexable: true },
  // The solution pages: one component, copy per page (content/solutions).
  { path: '/solutions/private-equity', page: 'SolutionPage', content: 'solutions/private-equity.js', indexable: true },
  { path: '/solutions/investment-banks', page: 'SolutionPage', content: 'solutions/investment-banks.js', indexable: true },
  { path: '/solutions/corporate-development', page: 'SolutionPage', content: 'solutions/corporate-development.js', indexable: true },
  { path: '/solutions/law-firms', page: 'SolutionPage', content: 'solutions/law-firms.js', indexable: true },
  { path: '/solutions/sell-side-m-and-a', page: 'SolutionPage', content: 'solutions/sell-side-m-and-a.js', indexable: true },
  { path: '/solutions/buy-side-due-diligence', page: 'SolutionPage', content: 'solutions/buy-side-due-diligence.js', indexable: true },
  { path: '/solutions/capital-raising', page: 'SolutionPage', content: 'solutions/capital-raising.js', indexable: true },
  { path: '/solutions/real-estate', page: 'SolutionPage', content: 'solutions/real-estate.js', indexable: true },
  { path: '/solutions/debt-financing', page: 'SolutionPage', content: 'solutions/debt-financing.js', indexable: true },
  { path: '/request-info', page: 'RequestInfoPage', content: 'requestInfo.js', indexable: true },
  { path: '/support', page: 'SupportPage', content: 'support.js', indexable: true },
  { path: '/privacy', page: 'PrivacyPage', content: 'privacy.js', indexable: true },
  { path: '/terms', page: 'TermsPage', content: 'terms.js', indexable: true },
  // nginx 301s /login to the app's sign-in (README "Deploy"); the page is the
  // fallback until it does.
  { path: '/login', page: 'LoginRedirectPage', indexable: false },
  // noindex on this host until status.diligenshub.com is served (StatusPage).
  { path: '/status', page: 'StatusPage', content: 'status.js', indexable: false },
  // Every other URL. The server sends 404.html with HTTP 404 (README "Deploy").
  { path: '*', page: 'NotFoundPage', content: 'notFound.js', indexable: false, file: '404.html' },
];
